import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/settlement-processing-list',
      name: 'admin-settlement-processing-list',
      component: () => import(/* webpackChunkName: "page-admin-settle-management-settlement-processing-list" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "结算处理"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "结算管理"
                                        },
                                        {
                                                  name: "结算处理"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
